var map = {
	"./Radiation_warning_symbol.svg": 20,
	"./Radiation_warning_symbol2.svg": 19,
	"./a.svg": 6,
	"./acid.svg": 18,
	"./invader.svg": 4,
	"./o.svg": 2,
	"./radioactive.svg": 3,
	"./rect.svg": 8,
	"./skull.svg": 17,
	"./skulls/1.svg": 16,
	"./skulls/2.svg": 15,
	"./skulls/3.svg": 14,
	"./skulls/4.svg": 13,
	"./skulls/5.svg": 12,
	"./skulls/6.svg": 11,
	"./skulls/7.svg": 10,
	"./skulls/8.svg": 9,
	"./square.svg": 5,
	"./x.svg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;